import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';
import { Label } from '@hydra/common/components';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import { Grid } from '@material-ui/core';

export class DescriptionIssueRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const urls = issue.urls.map(url => new DCUrl(domain, url));

    return (
      <Grid container className={classNameProp} alignItems='flex-start' key={issue.__dataID__}>
        <Grid item {...columnStyles[0]}>
          <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.urls.length} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          {`${issue.description_len_chr} (${issue.description_len_px}px)`}
        </Grid>
        <Grid item {...columnStyles[2]}>
          <Label noBackground title={issue.description} truncate>
            {issue.description}
          </Label>
        </Grid>
        <Grid item {...columnStyles[3]}>
          <List style={parseSeverity(issue.severity)} items={urls} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(DescriptionIssueRow, {
  issue: graphql`
    fragment DescriptionIssueRow_issue on DescriptionIssue {
      id
      severity
      description
      description_len_chr
      description_len_px
      type
      urls
    }
  `
});
